import isEmpty from 'lodash/isEmpty';

const getOrderFromProps = props => {
  const { managed = {} } = props;
  const { soundcasts = {} } = managed;
  const { order = {} } = soundcasts;
  return order;
};

// a little function to help us with reordering the result
const reorderInArray = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const sortingSoundcasts = (soundcastsManaged, orderedIds) => {
  if (isEmpty(soundcastsManaged)) {
    return [];
  }

  if (isEmpty(orderedIds)) {
    return soundcastsManaged;
  }

  const soundcastsManagedIds = soundcastsManaged.map(value => value.soundcastId);
  let diffItems = soundcastsManagedIds.filter(item => !orderedIds.includes(item));
  if (!isEmpty(diffItems)) {
    orderedIds = [...orderedIds, ...diffItems];
  }

  let soundcasts = [];
  orderedIds.forEach(id => {
    const soundcast = soundcastsManaged.find(i => i.soundcastId === id);
    if (!isEmpty(soundcast)) {
      soundcasts.push(soundcast);
    }
  });

  return soundcasts;
};

const sortingAllSoundcastsInBundle = (soundcastsAll, soundcastsIncluded, orderedIds) => {
  if (isEmpty(soundcastsAll)) {
    return [];
  }

  if (isEmpty(soundcastsIncluded)) {
    return soundcastsAll;
  }

  let checkedSoundcasts = [];
  let publishedSoundcasts = [];
  let draftSoundcasts = [];

  // add soundcasts to orderedIds that are not included in includedIds
  let diffItems = soundcastsIncluded.filter(item => !orderedIds.includes(item.id));
  if (!isEmpty(diffItems)) {
    orderedIds = [...orderedIds, ...diffItems.map(item => item.id)];
  }

  // get marked in sorted order
  orderedIds.forEach(id => {
    const soundcast = soundcastsAll.find(item => item.id === id);
    if (!isEmpty(soundcast)) {
      checkedSoundcasts.push(soundcast);
    }
  });

  // get published and draft
  soundcastsAll.forEach(soundcast => {
    if (!checkedSoundcasts.map(item => item.id).includes(soundcast.id)) {
      if (soundcast.published) {
        publishedSoundcasts.push(soundcast);
      } else {
        draftSoundcasts.push(soundcast);
      }
    }
  });

  // first marked in sorted order
  // then published
  // then draft (!published)
  return [...checkedSoundcasts, ...publishedSoundcasts, ...draftSoundcasts];
};

const createOrderedSoundcasts = (soundcasts, order) => {
  if (isEmpty(soundcasts) || isEmpty(order)) {
    return [];
  }

  const { dashboardSoundcastIds = {} } = order;
  const { orderedIds = [] } = dashboardSoundcastIds;
  if (isEmpty(orderedIds)) {
    return soundcasts;
  }

  return sortingSoundcasts(soundcasts, orderedIds);
};

const createOrderedBundles = (soundcasts, order) => {
  if (isEmpty(soundcasts) || isEmpty(order)) {
    return [];
  }

  const { dashboardBundleIds = {} } = order;
  const { orderedIds = [] } = dashboardBundleIds;
  if (isEmpty(orderedIds)) {
    return soundcasts;
  }

  return sortingSoundcasts(soundcasts, orderedIds);
};

const takeBundleSoundcastsOrderIds = (bundleId, order) => {
  if (isEmpty(bundleId) || isEmpty(order)) {
    return [];
  }

  const { dashboardBundleSoundcastIds: orderedInBundles = {} } = order;
  if (isEmpty(orderedInBundles) || !Object.keys(orderedInBundles).includes(bundleId)) {
    return [];
  }

  return orderedInBundles[bundleId];
};

const createOrderedBundleSoundcasts = (nextProps, prevState) => {
  let { soundcasts } = prevState;

  if (isEmpty(soundcasts)) {
    const { soundcastId, order = {} } = nextProps;

    const orderedIds = takeBundleSoundcastsOrderIds(soundcastId, order);
    soundcasts = sortingAllSoundcastsInBundle(nextProps.items, nextProps.selectedItems, orderedIds);
  }

  return soundcasts;
};

export {
  getOrderFromProps,
  reorderInArray,
  createOrderedSoundcasts,
  createOrderedBundles,
  createOrderedBundleSoundcasts,
};
